export const environment = {
  production: true,
  apiKey: "AIzaSyAR21OFpIVmUfmHHZAyFV7roxUscxsGKDM",
  authDomain: "balkan-recipes.firebaseapp.com"
};



// WEBPACK FOOTER //
// ./environments/environment.prod.ts